import type { EquivalentFossilVehicle, GasVehicle, Vehicle } from '../../types';

const isGasVehicle = (vehicle: Vehicle): vehicle is EquivalentFossilVehicle | GasVehicle => {
  return 'GAS' === vehicle.fuelType.toUpperCase();
};

export default isGasVehicle;
